import React from 'react'
import ProductImage from './index'

export const PayrollProductImage = () => {
  return <ProductImage imageSource="/assets/img/app-logo/payroll.png" color="#81352e" />
}
